import React, { useRef, useEffect, useState } from 'react';
import { ThemeProvider } from '@aws-amplify/ui-react';
import { CircleX, CircleAlert, Info, X } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { ModalErroReact } from '../../modals/ModalErroReact.js';
import Select from 'react-select';
import { CountdownBar } from '../../components/CountdownBar.tsx';
import InternetStatus from '../../components/conexao.tsx';
import HeaderHora from '../../components/headerHora.tsx';
import TentativaStatus from "../../components/tentativas.tsx";
import { ChevronDown } from 'lucide-react';
import comprovanteImg from '../../assets/comprovante.png';

export function ValidaIdentidadePixReact() {

  const intervalRef = useRef(null);

  const [listaBaas, setlistaBaas] = useState([]);
  const [loadButtonPix, setLoadButtonPix] = useState(false);
  const [loadButtonCod, setLoadButtonCod] = useState(false);
  const [step, setStep] = useState('instrucoes');
  const [loading, setLoading] = useState(true);
  const [instituicao, setInstituicao] = useState({});
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');
  const [tipoConta, setTipoConta] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [progresso, setProgresso] = useState(25);
  const [tentativas, setTentativas] = useState(1);

  const [modalAberto, setModalAberto] = useState(false);
  const handleNaoAchando = () => setModalAberto(true);

  const [modalErroOpen, setModalErroOpen] = useState(false);
  const [modalErroValidOpen, setModalErroValidOpen] = useState(false);
  const [modalErroCodOpen, setModalErroCodOpen] = useState(false);
  const [mensagemErro, setMensagemErro] = useState('');
  const [botaoHabilitado, setBotaoHabilitado] = useState(false);
  const [botaoHabilitadoCod, setBotaoHabilitadoCod] = useState(false);
  const [aberto, setAberto] = useState(null);

  const navigate = useNavigate();

  const [codigo, setCodigo] = useState(['', '', '', '', '', '']);
  const inputRefs = useRef([]);

  const options = listaBaas.map(item => ({
    value: item.istCode,
    label: `${item.istName} - ${item.istCode}`
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#f2f2f2',
      border: 'none',
      borderRadius: '4px',
      padding: '4px 0', // pequeno ajuste para manter altura parecida
      fontSize: '16px',
      color: '#4a4a4a',
      boxShadow: 'none',
      minHeight: '48px', // padding 14px + border e ajuste
      '&:hover': {
        border: 'none'
      }
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#A3A3A3'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#4a4a4a'
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '4px',
      zIndex: 10
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#e0e0e0' : '#fff',
      color: '#4a4a4a',
      padding: '10px 12px',
      cursor: 'pointer'
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#4a4a4a'
    }),
    indicatorSeparator: () => ({
      display: 'none'
    })
  };

  const handleChange = (index, value) => {
    if (value.length > 1) return; // impede mais de 1 caractere
    const novoCodigo = [...codigo];
    novoCodigo[index] = value;
    setCodigo(novoCodigo);

    // move para o próximo input automaticamente
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // se apertar backspace e estiver vazio, volta pro anterior
    if (e.key === 'Backspace' && codigo[index] === '' && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  useEffect(() => {
    listaBaasPix();
    setLoading(false);
    
    let infoLink = JSON.parse(sessionStorage.getItem('dadosLinkAtual'));

    if(infoLink.outValidacaoBancaria === 'S'){
      if(infoLink.outStatus === 'C'){
        navigate('finalizado');
      }
      else{
        navigate('/sucesso');
      }
    }
    else if(infoLink.outValidacaoBancaria === 'V'){
      setStep('processando');
      intervalRef.current = setInterval(verifica, 3000);
    }
    else if(infoLink.outValidacaoBancaria === 'C'){
      setStep('check');
      setTentativas(sessionStorage.getItem('nTentativasPix') || 1)
    }
    else if(infoLink.outValidacaoBancaria === 'S'){
      setStep('sucesso');
    }
    else{
      setStep('instrucoes');
    }

    return () => clearInterval(intervalRef.current);
  }, [navigate]);

  useEffect(() => {
    if (instituicao && agencia && conta && tipoConta) {
      setBotaoHabilitado(true);
    } else {
      setBotaoHabilitado(false);
    }

    if (codigo.every(item => item !== '')) {
      setBotaoHabilitadoCod(true);
    } else {
      setBotaoHabilitadoCod(false);
      console.log(codigo.length)
    }
  }, [instituicao, agencia, conta, tipoConta, codigo]);
  
  

  const DadosTransacaoPix = async () => {
    try{
      setLoadButtonPix(true);

      const res = await fetch(`${process.env.REACT_APP_URL_API}/conform/dados-transacao`, {
          method: 'POST',
          headers: {
              'Authorization': `Bearer ${sessionStorage.getItem('sessionTokenBearer')}`,
              'token': sessionStorage.getItem('sessionToken'),
              'x-TipoConta': tipoConta,
              'x-Instituicao': instituicao.istFullName,
              'x-Participant': instituicao.istIsbp,
              'x-Conta': conta,
              'x-Agencia': agencia,
              'x-Token': sessionStorage.getItem('sessionToken')
          }
      });
      
      const data = await res.json();
      if(data.erros === false){
        setLoadButtonPix(false);
        const raw = sessionStorage.getItem('dadosLinkAtual');
        const obj = raw ? JSON.parse(raw) : {};
        obj.outValidacaoBancaria = "V";
        sessionStorage.setItem('dadosLinkAtual', JSON.stringify(obj));
        setStep('processando');
        setProgresso(progresso + 25)
        intervalRef.current = setInterval(verifica, 3000);
      } else {
        setModalErroValidOpen(true);
        setLoadButtonPix(false);
      }
    }
    catch (err){
      setLoadButtonPix(false);
      setModalErroOpen(true);
        console.error("Erro ao enviar arquivo para o S3:", err);
    }
  }

  const verifica = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_URL_API}/conform/verifica`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('sessionTokenBearer')}`,
          'x-token': sessionStorage.getItem('sessionToken')
        }
      });

      const data = await res.json();

      if (data[0] === 'C') {
        clearInterval(intervalRef.current);
        const raw = sessionStorage.getItem('dadosLinkAtual');
        const obj = raw ? JSON.parse(raw) : {};
        obj.outValidacaoBancaria = "C";
        sessionStorage.setItem('dadosLinkAtual', JSON.stringify(obj));
        setStep('check')
      } else if (data[0] === 'E') {
        clearInterval(intervalRef.current);
        setStep('formulario')
        setModalErroOpen(true);
      }
      
    } catch (err) {
      console.error('Erro na requisição:', err);
    }
  };

  const finalizarToken = async () => {

        navigate('/sucesso');
  }

  const confirmaPass = async () => {
    setLoadButtonCod(true);

    const code = codigo.join('');

    try {
      const res = await fetch(`${process.env.REACT_APP_URL_API}/conform/envia-pass`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('sessionTokenBearer')}`,
          'x-token': sessionStorage.getItem('sessionToken'),
          'x-pass': code
        }
      });

      const data = await res.json();

      if (data.erros === false && data.retorno === 'APROVADO') {
        const raw = sessionStorage.getItem('dadosLinkAtual');
        const obj = raw ? JSON.parse(raw) : {};
        obj.outValidacaoBancaria = "S";
        obj.outStatus = "F";
        sessionStorage.setItem('dadosLinkAtual', JSON.stringify(obj));
        setProgresso(prev => prev + 25);
        setStep('sucesso')
      } else if (data.retorno === 'INVALIDO') {
        setMensagemErro('Código inválido. Confira se você digitou corretamente os 6 últimos caracteres encontrados no “ID da transação”.')
        setTentativas(Number(data.tentativas) + 1)
        sessionStorage.setItem('nTentativasPix', tentativas);
        setModalErroOpen(true);
        setLoadButtonCod(false);
      } else if (data.retorno === 'REPROVADO') {
        const raw = sessionStorage.getItem('dadosLinkAtual');
        const obj = raw ? JSON.parse(raw) : {};
        obj.outValidacaoBancaria = "S";
        obj.outStatus = "C";
        sessionStorage.setItem('dadosLinkAtual', JSON.stringify(obj));
        navigate('/finalizado');
      }
      
    } catch (err) {
      setModalErroOpen(true);
      setLoadButtonCod(false);
      console.error('Erro na requisição:', err);
    }
  };

  const handleEnviarFormulario = () => {
    setLoadButtonPix(true);

    if (validarFormulario()) {
      DadosTransacaoPix()
    } else {
      setLoadButtonPix(false);
    }
  };

  const validarFormulario = () => {
    if (!instituicao) {
      setMensagemErro("Selecione a instituição bancária.");
      setModalErroOpen(true);
      return false;
    }
    if (!agencia || !/^\d+$/.test(agencia)) {
      setMensagemErro("Informe a agência corretamente (apenas números).");
      setModalErroOpen(true);
      return false;
    }
    if (!conta || !/^\d+$/.test(conta)) {
      setMensagemErro("Informe a conta corretamente (apenas números).");
      setModalErroOpen(true);
      return false;
    }
    if (!tipoConta) {
      setMensagemErro("Selecione o tipo da conta.");
      setModalErroOpen(true);
      return false;
    }
  
    return true;
  };
  
  const reiniciar = async () => {
    setTimeout(() => setStep('instrucoes'), 100);
  };
  
  const listaBaasPix = async () => {
    try {
      const response = await fetch(
        `https://security.xpdstlsecurity.org/conform/instituicoes`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${sessionStorage.getItem('sessionTokenBearer')}`
          }
        }
      );
  
      const dataBaas = await response.json(); // <- isso aqui que faltava
      setlistaBaas(dataBaas);
    } catch (err) {
      console.error('Erro ao listar participantes Pix:', err);
    }
  };
  

  return (
<ThemeProvider>
  {loading ? (
    <div className='content'>
      <div className='content-loading'>
        <span className="loader"></span>
        <p className='text-load'>Tokenização bancária em andamento.</p>
        <p className='subtext-load'>Iniciando sua tokenização bancária. Permaneça na tela, o próximo passo aparecerá em instantes.</p>
      </div>
    </div>
  ) : (
    <>
      {step === 'instrucoes' && (
        <div className='content'>
          <div className='content-instrucao'>
            <div className='header'>Tokenização Bancária <HeaderHora/></div>
            <div className='status-face'>
                <CountdownBar/>
            </div>
            <div className='regras-face'>
              <span className='text-2'>Para garantir a autenticidade da sua assinatura eletrônica e proteger seus dados, realizaremos uma etapa adicional de segurança por meio de tokenização bancária. <strong>Este procedimento atende aos critérios de assinatura eletrônica avançada (Lei Federal nº 14.063/2020).</strong> </span>

              <div className='flex-row-between-center' >
                <p class="step-title">Como funciona:</p>
                <span className='link' onClick={() => setStep('duvida')}>Dúvidas? Clique aqui</span>
              </div>


              <div class="step">
                <p class="step-title">1. Informe uma conta bancária em seu nome</p>
                <p class="step-description">A conta deve estar vinculada ao seu CPF. Não aceitamos contas de terceiros.</p>
                <div class="info-box">
                  <span>A conta pode estar sem saldo ou até negativa, ela só precisa estar ativa e em seu nome.</span>
                </div>
              </div>

              <div class="step">
                <p class="step-title">2. Receba um PIX de R$0,01</p>
                <p class="step-description">Você receberá automaticamente um PIX simbólico no valor de R$ 0,01.</p>
                <div class="info-box">
                  <span>Fique tranquilo(a), não haverá qualquer cobrança. O valor é utilizado somente para confirmar sua identidade.</span>
                </div>
              </div>

              <div class="step">
                <p class="step-title">3. Digite o código de autenticação na plataforma</p>
                <p class="step-description">Use os 6 últimos números do "ID da transação" como código de verificação.</p>
                <div class="info-box">
                  <span>Para localizar o ID da transação, acesse o comprovante do PIX recebido. Ele está entre os últimos códigos exibidos, composto por letras e números.</span>
                </div>
              </div>

              <button onClick={() => setStep('formulario')}>Iniciar Tokenização Bancária</button>
            </div>
          </div>
        </div>
      )}

      {step === 'duvida' && (
        <div className='content'>
          <div className='content-instrucao'>
            <div className='header'>Tokenização Bancária <HeaderHora/></div>
            <div className='status-face'>
                <CountdownBar/>
                
            </div>
            <div className="faq-container">
              <button className="faq-back-link" onClick={() => setStep('instrucoes')}>
                ← Voltar
              </button>

              <p className="faq-title">Perguntas Frequentes (F.A.Q)</p>

              {[
                {
                  pergunta: 'Por que preciso receber um PIX de R$ 0,01?',
                  resposta: 'O valor é apenas simbólico e serve para confirmar que a conta informada está em seu nome. Não se trata de cobrança.',
                },
                {
                  pergunta: 'Preciso devolver o valor recebido?',
                  resposta: 'Não. O valor não precisa ser devolvido e não haverá nenhuma cobrança.',
                },
                {
                  pergunta: 'Onde encontro o ID da transação?',
                  resposta: 'O ID está no comprovante do PIX recebido, geralmente na parte inferior...',
                  imagem: comprovanteImg, // sua imagem
                },
                {
                  pergunta: 'Qual parte do ID devo informar?',
                  resposta: 'Digite apenas os 6 últimos caracteres do ID da transação. No exemplo acima, o código a ser informado seria: 7d5656.',
                },
                {
                  pergunta: 'E se eu errar o código?',
                  resposta: 'Você tem até 3 tentativas. Após esse limite, o processo será reiniciado por segurança.',
                },
                {
                  pergunta: 'Quanto tempo leva a análise final?',
                  resposta: 'A confirmação da identidade pode levar até 24 horas. Você será informado(a) quando a análise for concluída.',
                },
              ].map((item, i) => (
                <div key={i} className={`faq-item ${aberto === i ? 'open' : ''}`}>
                  <button className="faq-question" onClick={() => setAberto(aberto === i ? null : i)}>
                    {item.pergunta}
                    <ChevronDown className="faq-chevron" size={18} />
                  </button>
                  <div className="faq-answer">
                    {item.resposta}
                    {item.imagem && (
                      <div className="faq-image-wrapper">
                        <img src={item.imagem} alt="Exemplo comprovante" />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {step === 'formulario' && (
        <div className='content'>
          <div className='content-liveness'>
            <div className='header'>Tokenização Bancária <HeaderHora/></div>
            <div className='status-face'>
                <CountdownBar/>
                
            </div>
           
            <div className='box-content'>
              <div className="form-header">
                <h2>Informe uma conta em seu nome</h2>
                <div className="progress-bar-track">
                  <div className="progress-bar-fill" style={{ width: `${progresso}%` }} />
                </div>
              </div>

              {/* form */}
                <div className="form-row">
                  <div className="form-group">
                    <label>Instituição bancária</label>
                    <Select
                                  options={options}
                                  value={options.find(option => option.value === instituicao?.istCode) || null}
                                  onChange={(selectedOption) => {
                                    if (selectedOption) {
                                      const selected = listaBaas.find(item => item.istCode === selectedOption.value);
                                      setInstituicao(selected);
                                    } else {
                                      setInstituicao(null); // ou setInstituicao({}) dependendo do seu estado inicial
                                    }
                                  }}
                                  placeholder="Selecione a instituição..."
                                  isClearable
                                  styles={customStyles}
                                />
                    <span className="hint">Selecione sua instituição bancária</span>
                  </div>
                  
                  <div className="form-group">
                    <label>Tipo de conta</label>
                    <select value={tipoConta} onChange={(e) => setTipoConta(e.target.value)}>
                      <option value="">Selecione o tipo de conta</option>
                      <option value="CACC">Conta corrente ou digital</option>
                      <option value="SVGS">Conta poupança</option>
                      <option value="SLRY">Conta salário</option>
                      <option value="TRAN">Conta de pagamentos</option>
                    </select>
                    <span className="hint">Selecione o tipo de conta, por exemplo: Conta Corrente.</span>
                  </div>
                </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Agência</label>
                  <input type="text" value={agencia} onChange={(e) => setAgencia(e.target.value)} placeholder="Exemplo: 0123" />
                  <span className="hint">Informe apenas o número, sem dígito.</span>
                </div>

                <div className="form-group">
                  <label>Conta</label>
                  <input type="text" value={conta} onChange={(e) => setConta(e.target.value)} placeholder="Exemplo: 12345-6" />
                  <span className="hint">Inclua o dígito, se houver.</span>
                </div>
              </div>

              <div className='item-lista'>
                <CircleAlert className='icon-primary-color' />
                <div className='text-item'>
                  <span className='text-topo'>Importante:</span>
                  <span className='text-baixo'>A conta informada deve estar em seu nome e vinculada ao seu CPF. Não aceitamos contas de terceiros por motivos de segurança e conformidade legal.</span>
                </div>
              </div>

              <button disabled={!botaoHabilitado || loadButtonPix} onClick={handleEnviarFormulario}>{loadButtonPix ? 'CARREGANDO...' : 'CONTINUAR'}</button>
            </div>
          </div>
        </div>
      )}

      {step === 'processando' && (
        <div className='content'>
          <div className='content-loading'>
            <span className="loader"></span>
            <p className='text-load'>Validação Pix em andamento.</p>
            <p className='subtext-load'>Estamos processando seu PIX de confirmação. Permaneça na tela, o próximo passo aparecerá em instantes.</p>
          </div>
        </div>
      )}

      {step === 'check' && (
        <div className='content'>
          <div className='content-liveness'>
            <div className='header'>Tokenização Bancária <HeaderHora/></div>
            <div className='status-face'>
                <CountdownBar/>
                {/* <InternetStatus/> */}
                <TentativaStatus atual={tentativas} total={3} />
            </div>
            <div className='regras-face'>
              <div className="form-header">
                <h2>Confira se você recebeu um PIX de R$0,01</h2>
                <div className="progress-bar-track">
                  <div className="progress-bar-fill" style={{ width: `${progresso}%` }} />
                </div>
              </div>

              <p className="intro-text">
                Enviamos um PIX simbólico de R$ 0,01 para a conta informada na etapa anterior. Siga os passos abaixo para localizar o código no comprovante e, em seguida, informe-o para concluir a validação.
              </p>

              <ol className="steps-list">
                <li><strong>Acesse o aplicativo do seu banco</strong><br />Abra a área de Extrato ou Extrato PIX.</li>
                <li><strong>Localize o PIX de R$ 0,01</strong><br />Procure a transação no valor de R$ 0,01, enviada por Sociiz Tecnologia e Meios de Pagamento.</li>
                <li><strong>Abra os detalhes da transação</strong><br />Toque na transação para visualizar o comprovante completo.</li>
                <li><strong>Encontre o "ID da transação"</strong><br />O ID geralmente aparece na parte inferior do comprovante, composto por letras e números.</li>
                <li><strong>Após localizar o código</strong><br />Depois de localizar os 6 últimos caracteres do ID da transação, clique no botão "Já identifiquei o código" para inseri-los.</li>
              </ol>

              <div className='item-lista'>
                <Info className='icon-primary-color' />
                <div className='text-item'>
                  <span className='text-baixo'>Esta etapa é necessária para assegurar a validade e a segurança da sua assinatura digital, vinculando sua identidade bancária ao processo eletrônico com rastreabilidade e prevenção a fraudes. O valor enviado é apenas simbólico, não precisa ser devolvido e não representa qualquer cobrança.</span>
                </div>
              </div>

              <div className="buttons-row">
                <button className="btn-outline" onClick={handleNaoAchando}>Não estou achando o código</button>
                <button className="btn-filled" disabled={loadButtonCod} onClick={() => {
                    setStep('validar');
                    setProgresso(prev => prev + 25);
                  }}>
                  {loadButtonCod ? 'CARREGANDO...' : 'Já identifiquei o código'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {step === 'validar' && (
        <div className='content'>
          <div className='content-liveness'>
            <div className='header'>Tokenização Bancária <HeaderHora/></div>
            <div className='status-face'>
                <CountdownBar/>
                <TentativaStatus atual={tentativas} total={3} />
            </div>
            <div className='regras-face'>
              <div className="form-header">
                <h2>Informe o código de verificação</h2>
                <div className="progress-bar-track">
                  <div className="progress-bar-fill" style={{ width: `${progresso}%` }} />
                </div>
              </div>

              <p>Abra o comprovante do PIX de R$ 0,01 e localize o ID da transação. Ele aparece na parte inferior, é composto por letras e números.</p>

              <h3 className="subtitle">Digite abaixo os 6 últimos caracteres desse ID.</h3>
  
              <div className="code-container">
                {codigo.map((valor, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={valor}
                    onChange={(e) => handleChange(index, e.target.value.toUpperCase())}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    ref={(el) => (inputRefs.current[index] = el)}
                    className="code-input"
                  />
                ))}
              </div>

              <div className='item-lista'>
                <CircleAlert className='icon-primary-color'/>
                <div className='text-item'>
                  <span className='text-topo'>Importante:</span>
                  <span className='text-baixo'>São <strong>permitidas até 3 tentativas</strong> de inserção do código. Em caso de três erros consecutivos, o processo será reiniciado automaticamente por segurança.</span>
                </div>
              </div>

              {/* <p className="support-text">
                Em caso de dúvidas, nossa <a href="#" className="support-link">equipe de suporte</a> está à disposição.
              </p> */}
              <div className="buttons-row">
                <button className="btn-outline" onClick={handleNaoAchando}>Não estou achando o código</button>
                <button className="btn-filled" disabled={!botaoHabilitadoCod || loadButtonCod} onClick={confirmaPass}>{loadButtonCod ? 'CARREGANDO...' : 'Vefiricar o código'}
                </button>
              </div>
              
            </div>
          </div>
        </div>
      )}

      {step === 'sucesso' && (
        <div className='content'>
          <div className='content-liveness'>
            <div className='header'>Tokenização Bancária <HeaderHora/></div>
            <div className='status-face'>
                <CountdownBar/>
                <InternetStatus/>
            </div>
            <div className='regras-face'>
              <h4 className="title">Código validado com sucesso!</h4>

              <p className="intro-text">
                O código informado corresponde aos 6 últimos caracteres do ID da transação.
              </p>

              <p className="intro-text">
                Isso significa que a etapa “Tokenização Bancária” foi concluída com sucesso e seus dados foram enviados para a próxima fase da confirmação de identidade. Agora, <strong>suas informações passarão por uma análise em bases de dados oficiais para confirmar a validade dos dados informados.</strong>
              </p>

              <p className="intro-text">
                Assim que a verificação for finalizada, você será comunicado(a) com o resultado. <strong>Por enquanto, não é necessário fazer mais nada, é só aguardar.</strong>
              </p>

              <div className='item-lista'>
                <Info className='icon-primary-color' />
                <div className='text-item'>
                  <span className='text-baixo'>A análise dos dados informados <strong>poderá ser concluída em até 24 horas</strong>. O resultado será comunicado após a finalização da verificação.</span>
                </div>
              </div>

              <button onClick={finalizarToken}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {modalAberto && (
        <div className="modal-overlay" onClick={() => setModalAberto(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setModalAberto(false)}>
              <X size={20} />
            </button>

            <h3 className="modal-title">Onde encontrar o "ID da transação"?</h3>

            <p className="modal-text">
              Para localizar o código de verificação, acesse o <strong>comprovante do PIX de R$ 0,01</strong> recebido na sua conta. O ID da transação geralmente aparece <strong>ao final do comprovante</strong>, após as informações principais da transação. Ele é um código alfanumérico (composto por letras e números).
            </p>

            <p className="modal-text">
              <strong>Para concluir a validação, utilize apenas os 6 últimos caracteres desse ID.</strong> Veja abaixo uma imagem de referência para ajudar você a localizá-lo no comprovante.
            </p>

            <div className="modal-image-wrapper">
              <img src={comprovanteImg} alt="Exemplo de comprovante PIX" />
            </div>

            <p className="modal-footer-text">
              No exemplo acima, o código a ser informado seria: <strong>7d5656.</strong>
            </p>
          </div>
        </div>
      )}
    </>
  )}

  <ModalErroReact isOpen={isOpen} onRequestClose={() => { setIsOpen(false); reiniciar(); }}>
    <div className='icon-result'>
      <CircleX color='#F71A1A' strokeWidth={2} size={120} />
    </div>
    <div className='text-4'>Não conseguimos confirmar sua presença.</div>
    <div className='text-5'>
      A imagem capturada não foi clara o suficiente para validar que você está presente. Verifique a iluminação, centralize o rosto e tente novamente.
    </div>
    <div className='buttons-group'>
      <button onClick={() => { setIsOpen(false); reiniciar(); }}>TENTAR NOVAMENTE</button>
    </div>
  </ModalErroReact>

  <ModalErroReact isOpen={modalErroOpen} onRequestClose={() => setModalErroOpen(false)}>
  <div className='icon-result'>
    <CircleX color='#F71A1A' strokeWidth={2} size={120} />
  </div>
  <div className='text-5'>
    {mensagemErro || 'Erro ao validar formulário'}
  </div>
  <div className='buttons-group'>
    <button onClick={() => setModalErroOpen(false)}>OK</button>
  </div>
  </ModalErroReact>

  <ModalErroReact isOpen={modalErroValidOpen} onRequestClose={() => setModalErroValidOpen(false)}>
  <div className='icon-result'>
    <CircleX color='#F71A1A' strokeWidth={2} size={120} />
  </div>
  <div className='text-4'>Dados bancários não correspondem ao CPF ou CNPJ do responsável</div>
  <div className='text-5'>
    {mensagemErro}
  </div>
  <div className='buttons-group'>
    <button onClick={() => setModalErroValidOpen(false)}>OK</button>
  </div>
  </ModalErroReact>

  <ModalErroReact isOpen={modalErroCodOpen} onRequestClose={() => setModalErroCodOpen(false)}>
  <div className='icon-result'>
    <CircleX color='#F71A1A' strokeWidth={2} size={120} />
  </div>
  <div className='text-4'>Código inváido. Tente novamente.</div>
  <div className='text-5'>
    {mensagemErro}
  </div>
  <div className='buttons-group'>
    <button onClick={() => setModalErroCodOpen(false)}>OK</button>
  </div>
  </ModalErroReact>
</ThemeProvider>

  );
}
